'use client';

import { useEffect, useState } from 'react';
import { TermosCondicoesService, type TermosCondicoes } from '../../lib/services/termos-condicoes.service';
import { trackClarityEvent } from '@/lib/clarity';

export default function TermosContent() {
    const [termo, setTermo] = useState<TermosCondicoes | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchTermos() {
            try {
                const data = await TermosCondicoesService.getAtivo('AMBOS');
                setTermo(data);
                if (data) {
                    trackClarityEvent(`termos_pagina_aberta: ${data.titulo.substring(0, 50)}`);
                }
            } catch (error) {
                console.error('Erro ao buscar termos:', error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchTermos();
    }, []);

    if (isLoading) {
        return (
            <div className="bg-gray-50 py-12 min-h-screen">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="bg-white rounded-lg shadow-md p-8 md:p-12 animate-pulse">
                        <div className="h-8 bg-gray-200 rounded w-1/2 mx-auto mb-8"></div>
                        <div className="space-y-4">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-4 bg-gray-200 rounded w-4/6"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Fallback se não houver termo publicado
    if (!termo) {
        return (
            <div className="bg-gray-50 py-12 min-h-screen">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="bg-white rounded-lg shadow-md p-8 md:p-12 text-center">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            Termos e Condições
                        </h1>
                        <p className="text-gray-600">
                            Não foi possível carregar os termos e condições no momento. Por favor, tente novamente mais tarde.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 py-12 min-h-screen">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
                        {termo.titulo}
                    </h1>

                    <div
                        className="prose prose-lg max-w-none text-justify terms-content text-black prose-headings:text-black prose-p:text-black prose-strong:text-black prose-ul:text-black prose-ol:text-black prose-li:text-black whitespace-pre-wrap"
                        dangerouslySetInnerHTML={{
                            __html: termo.conteudo.replace(/<p><\/p>/g, '<br>')
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
